export function isArray(val: any): val is SerializableArray {
  return Array.isArray(val);
}

export function isObject(val: any): val is SerializableObject {
  return typeof val === 'object' && !isNull(val) && !isArray(val);
}

export function isString(val: any): val is string {
  return typeof val === 'string';
}

export function isNull(val: any): val is null {
  return val === null;
}

export function isNumber(val: any): val is number {
  return typeof val === 'number';
}

export function isBoolean(val: any): val is boolean {
  return typeof val === 'boolean';
}

export function isPrimitive(val: any): val is SerializablePrimitive {
  return isNull(val) || isString(val) || isBoolean(val) || isNumber(val);
}

export function isUndefined(val: any): val is undefined {
  return typeof val === 'undefined';
}

export function objectSize(obj: SerializableObject) {
  return Object.keys(obj).length;
}

export function arraySize(arr: SerializableArray) {
  return arr.length;
}

export type SerializablePrimitive = string | number | boolean | null;

export type SerializableObject = {
  [key: string]: SerializablePrimitive | SerializableObject | SerializableArray;
};

export type SerializableArray = Array<
  SerializablePrimitive | SerializableObject | SerializableArray
>;

export type Serializable =
  | SerializablePrimitive
  | SerializableObject
  | SerializableArray;
